/**
 * AddMoreDialog.jsx — modal that lets the user add more ETFs after the
 * analysis has already been computed, then re-run the analysis with the
 * extended portfolio.
 *
 * Phase 36 (UI simplification): uses the same SelectionPanels component
 * as the pre-analysis screen (no more <Workspace mode="full">).
 */
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2, BarChart3 } from "lucide-react";

import { SelectionPanels } from "@/components/SelectionPanels";


export function AddMoreDialog({ open, onOpenChange, workspaceProps }) {
  const {
    knownEtfs, selectedEtfs, setSelectedEtfs,
    onPasteSubmit, pasteBusy,
    processing, processFiles,
    selectionLimitReached, onLimitHit,
  } = workspaceProps || {};

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-5xl bg-surface border-line text-content"
        data-testid="add-more-dialog"
      >
        <DialogHeader>
          <DialogTitle className="text-base">Aggiungi altri ETF</DialogTitle>
          <DialogDescription className="text-xs text-content-muted">
            Incolla nuovi ISIN o seleziona ETF dal catalogo, poi avvia
            nuovamente l'analisi con il portafoglio aggiornato.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-2 space-y-4">
          <SelectionPanels
            onPasteSubmit={onPasteSubmit}
            pasteBusy={pasteBusy}
            knownEtfs={knownEtfs}
            selectedEtfs={selectedEtfs}
            setSelectedEtfs={setSelectedEtfs}
            selectionLimitReached={selectionLimitReached}
            onLimitHit={onLimitHit}
            disabled={processing}
          />
          <div className="flex items-center justify-end gap-3 border-t border-line pt-3">
            <Button
              variant="ghost"
              onClick={() => onOpenChange(false)}
              data-testid="add-more-cancel"
            >
              Annulla
            </Button>
            <Button
              onClick={processFiles}
              disabled={processing || pasteBusy}
              data-testid="add-more-process"
              className="bg-brand hover:bg-brand-hover text-content-on-brand"
            >
              {processing ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Analisi…
                </>
              ) : (
                <>
                  <BarChart3 className="mr-2 h-4 w-4" />
                  Ri-esegui Analisi
                </>
              )}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default AddMoreDialog;
